import React from 'react';
export function ArrowRightIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.726 11.287l-7.061-7.082a1 1 0 10-1.416 1.412l5.356 5.372-11.585-.017a1 1 0 100 2l11.586.017-5.376 5.356a1 1 0 101.412 1.416l7.082-7.06a1 1 0 000-1.414h.002z"
  }));
}